import {UserLocal} from "@app/core/user/domain/user.local";
import {User} from "@app/core/user/domain/entities/user";
import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {StorageLocal} from "@app/core/shared/domain/storage/storage.local";


@Injectable({
    providedIn: "root",
})

export class UserLocalStorage extends UserLocal {


    private isLoggedInSubject = new BehaviorSubject<boolean>(false);
    public isLoggedIn$: Observable<boolean> = this.isLoggedInSubject.asObservable();

    private isGuestSubject = new BehaviorSubject<boolean>(false);
    public isGuest$: Observable<boolean> = this.isGuestSubject.asObservable();

    private USER_STORAGE_KEY = 'user';

    private HOME_WAS_VISITED = "home-was-visited"

    constructor(
        private localStorage: StorageLocal,
    ) {
        super();
        this.isLoggedInSubject.next(this.getUser() !== null)
        this.isGuestSubject.next(this.getUser()?.isGuest ?? false)
    }

    saveUser(user: User): void {
        this.localStorage.setItem(this.USER_STORAGE_KEY, JSON.stringify(user));
        this.isLoggedInSubject.next(true);
        this.isGuestSubject.next(user.isGuest);
    }

    getUser(): User | null {
        let userString = this.localStorage.getItem(this.USER_STORAGE_KEY)
        if (userString) {
            return JSON.parse(userString) as User
        }
        return null;
    }

    getIfHasVisitedTheLanding(): boolean {
        let homeWasVisited = this.localStorage.getItem(this.HOME_WAS_VISITED)
        return !!homeWasVisited;
    }

    setVisitedTheLanding() {
        this.localStorage.setItem(this.HOME_WAS_VISITED, JSON.stringify(true))
    }

    logout(): void {
        this.localStorage.removeItem(this.USER_STORAGE_KEY);
        this.isLoggedInSubject.next(false);
    }

}
